export default {
      id: "oc-res-kafka-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-kafka",
      toString: function () {
        return this.url;
      }
    }